import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ArrowUpRight, Check, Sparkles, Eye, MessageCircle, Bot, Mail, Plus, Minus } from "lucide-react";

const CAL_LINK = "https://cal.com/kalza-studio-hdho6x";
const EMAIL = "hello@kalzastudio.com";

const Highlight = ({ children }) => (
  <span className="relative inline-block font-accent">
    <span className="absolute left-0 right-0 bottom-[0.08em] h-[0.8em] bg-[#BE123C] -z-0" />
    <span className="relative z-10">{children}</span>
  </span>
);

const OrganicImage = ({ src, alt, className = "" }) => (
  <div className={`aspect-[4/5] overflow-hidden max-w-[65%] lg:max-w-none ${className}`} style={{ WebkitMaskImage: 'url(/images/mood/shape-mask.png)', maskImage: 'url(/images/mood/shape-mask.png)', WebkitMaskSize: '100% 100%', maskSize: '100% 100%', WebkitMaskRepeat: 'no-repeat', maskRepeat: 'no-repeat' }}>
    <img src={src} alt={alt || ""} className="w-full h-full object-cover" />
  </div>
);

const PRODUCTS = [
  {
    id: "make-me-memorable",
    Icon: Sparkles,
    eyebrow: "AUDYT TREŚCI",
    name: "Make Me Memorable",
    tagline: "Twoje treści przestają wtapiać się w tłum",
    price: "€29",
    pricePLN: "129 PLN",
    bestFor: "Dla osób, których posty, bio i podpisy brzmią generycznie i są natychmiast zapominane",
    description: "Agent AI, który czyta Twoje treści i mówi Ci dokładnie gdzie brzmisz jak wszyscy inni w Twojej niszy. Ocenia pięć warstw: atmosferę, vibe wizualny, hooki, przekaz, ostrość. Potem przepisuje najsłabsze części głosem, który faktycznie zostaje w głowie.",
    includes: [
      "Ocenia Twoje treści w pięciu warstwach zapamiętywalności",
      "Przepisuje hooki i bio, które nie trafiają",
      "Mówi Ci dlaczego coś nie gra, nie tylko że nie gra",
      "Wklej cokolwiek, dostań feedback w czasie rzeczywistym",
    ],
    checkoutUrl: "#",
    learnMoreUrl: "#",
  },
  {
    id: "stories-that-sell",
    Icon: MessageCircle,
    eyebrow: "INSTAGRAM STORIES",
    name: "Stories That Sell",
    tagline: "Sekwencje, które faktycznie konwertują",
    price: "€49",
    pricePLN: "199 PLN",
    bestFor: "Dla osób sprzedających usługi lub produkty cyfrowe przez Instagram Stories",
    description: "69 sprawdzonych sekwencji Stories na każdy etap kampanii sprzedażowej. Budowanie zaufania, obsługa obiekcji, dzień launchu, ciche domykanie. Agent dopasowuje każdą sekwencję do Twojej oferty, odbiorców i tonu, więc nic nie brzmi jak szablon.",
    includes: [
      "69 gotowych sekwencji od rozgrzewki po domknięcie sprzedaży",
      "Scenariusze do nagrania, napisania albo przerobienia na karuzele",
      "Dopasowuje każdy output do Twojej oferty i Twojego głosu",
      "Działa w każdym języku",
    ],
    checkoutUrl: "#",
    learnMoreUrl: "#",
  },
  {
    id: "brand-blind-spots",
    Icon: Eye,
    eyebrow: "DIAGNOSTYKA TOŻSAMOŚCI",
    name: "Brand Blind Spots",
    tagline: "Zobacz to, czego sama nie widzisz",
    price: "€69",
    pricePLN: "299 PLN",
    bestFor: "Dla osób, które chcą zbudować coś własnego, no ale brakuje im pewności siebie i boją się obszarów, które ich przytłoczą",
    description: "Prowadzona diagnostyka, która nazywa lukę między tym kim naprawdę jesteś a tym jak Twoja marka się obecnie prezentuje. Pracuje przez blokady tożsamościowe, wzorce people-pleasingu i perfekcjonizmu, aż zobaczysz co Twoja marka ukrywa. Produkuje manifest, filary treści i jasny kierunek.",
    includes: [
      "Zadaje pytania diagnostyczne zanim przeskoczy do odpowiedzi",
      "Nazywa ślepe punkty i blokady tożsamościowe, których sama nie widzisz",
      "Buduje manifest marki Twoimi słowami",
      "Daje Ci konkretny plan, który możesz zacząć jutro",
    ],
    checkoutUrl: "#",
    learnMoreUrl: "#",
  },
  {
    id: "dna-voice",
    Icon: Bot,
    eyebrow: "OSOBISTY AGENT AI",
    name: "DNA Voice",
    tagline: "AI, które pisze jak Ty, nie jak ChatGPT",
    price: "€97",
    pricePLN: "399 PLN",
    bestFor: "Dla osób zmęczonych poprawianiem generycznego outputu AI i przepisywaniem każdego draftu swoim głosem",
    description: "Osobisty agent AI wytrenowany na Twoim głosie pisania przez dziesięciowarstwową analizę. Zadaje pytania diagnostyczne, wyłapuje Twój rytm i odruchy i staje się jedynym narzędziem AI, które faktycznie brzmi jak Ty w dobry dzień. Używaj go do podpisów, maili, stron sprzedażowych i newsletterów.",
    includes: [
      "W pełni spersonalizowany pod Twój głos pisania",
      "Wydobywa Twój głos przez dziesięć warstw diagnostycznych",
      "Uczy się Twojego rytmu, Twoich odruchów, Twojej ostrości",
      "Wszystko co pisze brzmi jak Ty w dobry dzień",
      "Działa w Claude i ChatGPT",
    ],
    checkoutUrl: "#",
    learnMoreUrl: "#",
  },
];

const REACTIONS = [
  { text: "wow! it really tells u stuff 👀 i love it!", product: "Brand Blind Spots" },
  { text: "f*cking hell 😂 i love that. It gave me some clarity", product: "Brand Blind Spots" },
  { text: "Ten agent to jest game changer 😍", product: "DNA Voice" },
  { text: "Wrote 5 Instagram captions in 20 minutes and for the first time they actually sounded like me, not like a chatbot wearing my name", product: "DNA Voice" },
  { text: "Hmmm, Ola, ten agent to jest coś pięknego. Chat GPT to przy tym kretyn 🙏", product: "DNA Voice + Make Me Memorable" },
  { text: "I kept putting off my rebrand for months because I could not figure out what was off. This thing told me in 40 minutes", product: "Make Me Memorable" },
  { text: "To jest doje*ane. Trafia w punkt. Wyłapał że nie mam konsekwencji w zarządzaniu zespołem, że kieruję się sympatią a nie konsekwencją. Spięło mnie to w kontekście tego jak chcę prowadzić restaurację. Rewolucyjne narzędzie jak ktoś myśli o założeniu swojej marki.", product: "Brand Blind Spots" },
  { text: "Pomógł mi znaleźć punkt w którym utknąłem który nie był dla mnie oczywisty", product: "Brand Blind Spots" },
  { text: "Fajne narzędzie które pomoże ci rozwiać wątpliwości i faktycznie nakierować na to co jest ważne", product: "Brand Blind Spots" },
  { text: "I used my mom's clothing store as a case study and the tool managed to identify the core issue really well. The language was super accessible and it built very structured hypotheses, I really thought that was impressive! I have no idea how you even build something at this level 😍", product: "Brand Blind Spots" },
];

const FAQ_ITEMS = [
  { q: "Czy potrzebuję Claude albo ChatGPT Plus, żeby tego używać?", a: "Tak. Każdy agent działa wewnątrz Twojego własnego projektu Claude albo Custom GPT. Potrzebujesz aktywnej subskrypcji jednej z tych platform. Pliki agentów działają też na darmowych kontach Claude, tylko z limitem free tier." },
  { q: "Czy to jest subskrypcja?", a: "Nie. Każdy produkt to jednorazowy zakup. Kupujesz agenta, jest Twój, używasz go tak długo jak chcesz." },
  { q: "Czym to się różni od zwykłego używania ChatGPT?", a: "Pracuję z ChatGPT i Claude od ok. czterech lat. Znam oba narzędzia od podszewki. To ma znaczenie, bo te agenty to nie są prompty z ładną nazwą. Niosą w sobie konkretną metodologię marki, którą szlifowałam na dziesiątkach projektów. Generyczne AI daje generyczny output. Te agenty dają Ci to samo myślenie, które wnoszę do pracy z klientami 1:1." },
  { q: "Czy mogę tego używać z moimi klientami?", a: "Tak, do Twojej własnej pracy z klientami. Nie możesz odsprzedawać ani redystrybuować samych plików agentów." },
  { q: "Co jeśli chcę coś bardziej spersonalizowanego?", a: "W bliższej pracy z moimi klientami 1:1 buduję też agentów zaprojektowanych wokół ich konkretnego biznesu, głosu i celów. Jak najbardziej do zrobienia. Umów rozmowę, a porozmawiamy o tym, czego faktycznie potrzebujesz." },
];

function FaqItem({ item, open, onToggle }) {
  return (
    <div className="border-t border-[#1C1210]/10">
      <button onClick={onToggle} className="w-full flex items-start justify-between gap-6 py-6 text-left group">
        <h3 className="font-serif text-lg text-[#1C1210] group-hover:text-[#BE123C] transition-colors duration-300">{item.q}</h3>
        <span className="flex-shrink-0 text-[#BE123C] mt-1">{open ? <Minus size={20} /> : <Plus size={20} />}</span>
      </button>
      {open && (<div className="pb-6"><p className="font-body text-sm text-[#6B6560] leading-[1.7]">{item.a}</p></div>)}
    </div>
  );
}

export default function AiProductsPagePL() {
  const [openFaq, setOpenFaq] = useState(null);

  return (
    <main data-testid="ai-products-page-pl">
      {/* ═══ 1. HERO ═══ */}
      <section className="relative pt-28 pb-16 md:pt-36 md:pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img src="/images/mood/dark-texture.jpg" alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-[#1C1210]/60" />
        </div>
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="max-w-2xl">
            <span className="font-eyebrow text-white mb-6 block">PRODUKTY AI OD KALZA STUDIO</span>
            <h1 className="mb-6">
              <span className="font-display text-4xl md:text-5xl lg:text-6xl text-white block leading-[0.95]">PRECYZYJNE NARZĘDZIA AI</span>
              <span className="font-accent text-2xl md:text-3xl lg:text-4xl text-[#BE123C] block leading-[1.1] mt-2">z prawdziwym myśleniem o marce w środku</span>
            </h1>
            <p className="font-body text-base md:text-lg text-white/60 leading-relaxed max-w-xl">
              Cztery agenty AI zbudowane na tej samej strategii marki, którą stosuję z klientami 1:1. Jednorazowy zakup, działają w Claude lub ChatGPT, Twoje na zawsze.
            </p>
          </motion.div>
        </div>
      </section>

      {/* ═══ 2. PRODUCTS GRID ═══ */}
      <section className="py-20 md:py-28 bg-[#f5f5f7]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="mb-16 max-w-2xl">
            <span className="font-eyebrow text-[#8B1A3A] mb-4 block">AGENTY</span>
            <h2>
              <span className="font-display text-3xl md:text-4xl text-[#1C1210] block leading-[0.95]">CZTERY SPOSOBY, ŻEBY</span>
              <span className="font-accent text-3xl md:text-4xl text-[#BE123C] block leading-[1.1] mt-1">Twoja marka trafiała mocniej</span>
            </h2>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {PRODUCTS.map((product, i) => (
              <motion.div key={product.id} id={product.id} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.1 }} className="bg-white border border-[#1C1210]/8 p-8 md:p-10 flex flex-col">
                <div className="mb-6">
                  <product.Icon size={28} className="text-[#BE123C] mb-5" strokeWidth={1.5} />
                  <span className="inline-block font-eyebrow text-[10px] tracking-[2px] text-[#8B1A3A] mb-3">AI AGENT · {product.eyebrow}</span>
                  <h3 className="font-display text-2xl md:text-3xl text-[#1C1210] leading-[1] mb-2">{product.name}</h3>
                  <p className="font-accent text-lg text-[#BE123C] leading-[1.2]">{product.tagline}</p>
                </div>
                <p className="font-body text-sm text-[#6B6560] leading-[1.7] mb-5">{product.description}</p>
                <div className="mb-6">
                  <p className="font-eyebrow text-[#1C1210] mb-3">CO DOSTAJESZ</p>
                  <ul className="space-y-2">
                    {product.includes.map((item, j) => (
                      <li key={j} className="flex items-start gap-2">
                        <Check size={14} className="text-[#BE123C] flex-shrink-0 mt-1" />
                        <span className="font-body text-sm text-[#4A4540] leading-relaxed">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="mb-5 pb-5 border-b border-[#1C1210]/8">
                  <p className="font-eyebrow text-[#6B6560]/70 mb-2">DLA KOGO</p>
                  <p className="font-body text-sm text-[#4A4540] italic leading-relaxed">{product.bestFor}</p>
                </div>
                <div className="mt-auto">
                  <div className="flex items-baseline gap-3 mb-5">
                    <span className="font-display text-3xl text-[#1C1210]">{product.price}</span>
                    <span className="font-body text-sm text-[#6B6560]">/ {product.pricePLN}</span>
                    <span className="font-body text-xs text-[#6B6560]/70 ml-auto">jednorazowo</span>
                  </div>
                  <div className="flex flex-col sm:flex-row gap-3">
                    <a href={product.checkoutUrl} className="flex-1 inline-flex items-center justify-center gap-2 bg-[#BE123C] text-white font-body font-medium text-xs tracking-[2px] uppercase px-6 py-4 hover:bg-[#9F1239] transition-colors duration-300">
                      KUP TERAZ <ArrowUpRight size={14} />
                    </a>
                    <Link to={product.learnMoreUrl} className="inline-flex items-center justify-center gap-2 border border-[#1C1210]/15 text-[#1C1210] font-body font-medium text-xs tracking-[2px] uppercase px-6 py-4 hover:border-[#BE123C] hover:text-[#BE123C] transition-colors duration-300">
                      WIĘCEJ <ArrowRight size={14} />
                    </Link>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ 3. REAKCJE ═══ */}
      <section className="py-20 md:py-28 bg-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="mb-12 max-w-3xl">
            <span className="font-eyebrow text-[#8B1A3A] mb-4 block">PIERWSZE REAKCJE</span>
            <h2 className="mb-6">
              <span className="font-display text-3xl md:text-4xl text-[#1C1210] block leading-[0.95]">WŁAŚCICIELE BIZNESÓW</span>
              <span className="font-accent text-3xl md:text-4xl text-[#BE123C] block leading-[1.1] mt-1">którzy to przetestowali</span>
            </h2>
            <p className="font-body text-sm text-[#6B6560] leading-relaxed max-w-xl">
              Niefiltrowane wiadomości od osób z wczesnym dostępem. Przekleństwa i emoji w zestawie. Poważne case study przyjdą kiedy agenty dojrzeją 😉
            </p>
          </motion.div>
        </div>
        <div className="relative overflow-hidden">
          <div className="flex animate-reactions-scroll-pl gap-5 py-2">
            {[...REACTIONS, ...REACTIONS].map((r, i) => (
              <div key={i} className="flex-shrink-0 w-[300px] md:w-[360px] bg-[#f5f5f7] px-5 py-4 rounded-2xl rounded-tl-sm border border-[#E8E3DE]/60">
                <p className="font-body text-[15px] text-[#1C1210] leading-[1.55]">{r.text}</p>
                <div className="mt-3 pt-3 border-t border-[#1C1210]/8">
                  <span className="font-eyebrow text-[9px] tracking-[1.5px] text-[#8B1A3A]">{r.product}</span>
                </div>
              </div>
            ))}
          </div>
          <style>{`
            @keyframes reactionsScrollPl { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
            .animate-reactions-scroll-pl { animation: reactionsScrollPl 80s linear infinite; width: max-content; }
            .animate-reactions-scroll-pl:hover { animation-play-state: paused; }
          `}</style>
        </div>
      </section>

      {/* ═══ 4. DLACZEGO TO ZBUDOWAŁAM ═══ */}
      <section className="py-20 md:py-28 bg-[#f5f5f7]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
              <OrganicImage src="/images/ola-ai-products.jpg" alt="Aleksandra Kałuża" />
            </motion.div>
            <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.1 }}>
              <span className="font-eyebrow text-[#8B1A3A] mb-4 block">DLACZEGO TO ZBUDOWAŁAM</span>
              <h2 className="mb-6">
                <span className="font-display text-3xl md:text-4xl text-[#1C1210] block leading-[0.95]">LUBIĘ BYĆ</span>
                <span className="font-accent text-3xl md:text-4xl text-[#BE123C] block leading-[1.1] mt-1">o krok przed tym co nadchodzi</span>
              </h2>
              <div className="space-y-4 font-body text-base text-[#6B6560] leading-[1.7]">
                <p>Studiowałam multimedia, no ale duża część tej edukacji to de facto była technologia: praca z automatyzacjami, projekty kreatywne i ta strona biznesu, którą większość ludzi nazywa IT. Pracuję w branży kreatywnej, no ale dzisiaj branża kreatywna jeździ na technologii.</p>
                <p>Kocham technologię. Kocham uczyć się nowych narzędzi. Nienawidzę powtarzalnych, nudnych zadań. Jeśli coś da się uprościć, usystematyzować albo zautomatyzować, zbuduję ten system. Używam AI w prawdziwej pracy z klientami od trzech lat. Dla mnie to nie jest nic nowego.</p>
                <p>W tym momencie znam te narzędzia na tyle dobrze, żeby zrobić z nich coś naprawdę użytecznego. Moi klienci są zadowoleni z tego, co te agenty produkują. To jest małe, dopracowane menu. Nie planuję wypuszczać nowych tylko po to, żeby mieć więcej produktów. Te zasłużyły na swoje miejsce.</p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ═══ 5. JAK TO DZIAŁA ═══ */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="mb-16 max-w-2xl">
            <span className="font-eyebrow text-[#8B1A3A] mb-4 block">JAK TO DZIAŁA</span>
            <h2>
              <span className="font-display text-3xl md:text-4xl text-[#1C1210] block leading-[0.95]">KUPUJESZ, PODŁĄCZASZ,</span>
              <span className="font-accent text-3xl md:text-4xl text-[#BE123C] block leading-[1.1] mt-1">zaczynasz używać dzisiaj</span>
            </h2>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-12">
            {[
              { step: "01", title: "Wybierz agenta", body: "Wybierz produkt, który pasuje do tego, czego Twoja marka teraz najbardziej potrzebuje. Kupujesz raz." },
              { step: "02", title: "Dostań pliki", body: "Dostajesz instrukcje agenta jako skill Claude albo konfigurację Custom GPT plus krótki poradnik konfiguracji." },
              { step: "03", title: "Używaj w swoim AI", body: "Wrzuć go do swojego projektu Claude albo workspace ChatGPT. Agent jest gotowy do pracy w momencie otwarcia." },
            ].map((s, i) => (
              <motion.div key={i} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.1 }} className="border-t border-[#1C1210]/15 pt-6">
                <span className="font-display text-4xl text-[#BE123C] block mb-4 leading-none">{s.step}</span>
                <h3 className="font-serif text-xl text-[#1C1210] mb-3">{s.title}</h3>
                <p className="font-body text-sm text-[#6B6560] leading-[1.7]">{s.body}</p>
              </motion.div>
            ))}
          </div>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.3 }}>
            <a href="#make-me-memorable" className="inline-flex items-center justify-center gap-2 bg-[#BE123C] text-white font-body font-medium text-xs tracking-[2px] uppercase px-8 py-4 hover:bg-[#9F1239] transition-colors duration-300">
              WYBIERZ AGENTA <ArrowRight size={14} />
            </a>
          </motion.div>
        </div>
      </section>

      {/* ═══ 6. DIVIDER ═══ */}
      <section className="relative py-20 md:py-28 overflow-hidden">
        <div className="absolute inset-0">
          <img src="/images/mood/dark-texture.jpg" alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-[#1C1210]/70" />
        </div>
        <div className="relative max-w-3xl mx-auto px-6 md:px-12 lg:px-24 text-center">
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
            <p className="font-serif text-xl md:text-2xl text-white leading-[1.5]">
              Szlifowałam tych agentów obsesyjnie, aż output był ostry, spójny i taki, z którego jestem dumna. Bo używam ich z własnymi klientami i zależy mi na <Highlight>jakości</Highlight> bardziej niż na czymkolwiek innym.
            </p>
          </motion.div>
        </div>
      </section>

      {/* ═══ 7. FAQ ═══ */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-3xl mx-auto px-6 md:px-12 lg:px-24">
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
            <span className="font-eyebrow text-[#8B1A3A] mb-6 block">CZĘSTE PYTANIA</span>
            <h2 className="mb-10">
              <span className="font-display text-3xl md:text-4xl text-[#1C1210] block leading-[0.95]">ZANIM KUPISZ</span>
            </h2>
            <div>
              {FAQ_ITEMS.map((item, i) => (
                <FaqItem key={i} item={item} open={openFaq === i} onToggle={() => setOpenFaq(openFaq === i ? null : i)} />
              ))}
              <div className="border-t border-[#1C1210]/10" />
            </div>
          </motion.div>
        </div>
      </section>

      {/* ═══ 8. FINAL CTA ═══ */}
      <section className="relative py-24 md:py-32 overflow-hidden">
        <div className="absolute inset-0">
          <img src="/images/mood/dark-texture.jpg" alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-[#1C1210]/70" />
        </div>
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="max-w-3xl">
            <span className="font-eyebrow text-white mb-6 block">POTRZEBUJESZ POMOCY?</span>
            <h2 className="mb-8">
              <span className="font-display text-3xl md:text-5xl text-white block leading-[0.95]">NIE WIESZ</span>
              <span className="font-accent text-3xl md:text-5xl text-[#BE123C] block leading-[1.1] mt-2">którego wybrać?</span>
            </h2>
            <p className="font-body text-base md:text-lg text-white/70 leading-relaxed mb-10 max-w-xl">
              Napisz mi krótką wiadomość. Powiem Ci, który agent pasuje do tego, czego faktycznie potrzebujesz. A jeśli to, czego potrzebujesz, to de facto Audit albo Brand Foundation, powiem Ci to też.
            </p>
            <a href={`mailto:${EMAIL}`} className="inline-flex items-center justify-center gap-2 bg-[#E11D48] text-white font-body font-medium text-xs tracking-[2px] uppercase px-10 py-5 hover:bg-[#BE123C] transition-colors duration-300">
              <Mail size={14} /> {EMAIL}
            </a>
          </motion.div>
        </div>
      </section>
    </main>
  );
}
